import './navigation-drawer'
import './navigation-dropdown'

import './cookies'
/* eslint-disable no-undef */
// import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs'

import ourTeams from './ourTeamData'

import aboutTestimonials from './aboutTestimonialData'

const preHeadingIcon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="#1DCA5D"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.8337 14.2283C13.2713 13.8583 14.3337 12.5532 14.3337 11C14.3337 9.15905 12.8413 7.66667 11.0003 7.66667C9.15938 7.66667 7.66699 9.15905 7.66699 11C7.66699 12.5532 8.7293 13.8583 10.167 14.2283V23.5C10.167 23.9602 10.5401 24.3333 11.0003 24.3333C11.4606 24.3333 11.8337 23.9602 11.8337 23.5V14.2283Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.667 21C17.667 19.4468 18.7293 18.1417 20.167 17.7717V12.6667C20.167 12.4457 20.0792 12.2337 19.9229 12.0774C19.7666 11.9211 19.5547 11.8333 19.3337 11.8333H16.8337C16.3734 11.8333 16.0003 11.4602 16.0003 11C16.0003 10.5398 16.3734 10.1667 16.8337 10.1667H19.3337C19.9967 10.1667 20.6326 10.4301 21.1014 10.8989C21.5703 11.3677 21.8337 12.0036 21.8337 12.6667V17.7717C23.2713 18.1417 24.3337 19.4468 24.3337 21C24.3337 22.8409 22.8413 24.3333 21.0003 24.3333C19.1594 24.3333 17.667 22.8409 17.667 21Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M17.6667 21C17.6667 19.4468 18.729 18.1417 20.1667 17.7717V12.6667C20.1667 12.4457 20.0789 12.2337 19.9226 12.0774C19.7663 11.9211 19.5543 11.8333 19.3333 11.8333H16.8333C16.3731 11.8333 16 11.4602 16 11C16 10.5398 16.3731 10.1667 16.8333 10.1667H19.3333C19.9964 10.1667 20.6323 10.4301 21.1011 10.8989C21.5699 11.3677 21.8333 12.0036 21.8333 12.6667V17.7717C23.271 18.1417 24.3333 19.4468 24.3333 21C24.3333 22.8409 22.8409 24.3333 21 24.3333C19.1591 24.3333 17.6667 22.8409 17.6667 21Z" fill="#77DF9E"/>
</svg>`

document
  .querySelectorAll('.testimonial__about--preHeadingIcon')
  .forEach((el) => {
    el.innerHTML += preHeadingIcon
  })
document.querySelector('.team__about--preHeadingIcon').innerHTML +=
  preHeadingIcon
document.querySelector('.teamActivity__about--preHeadingIcon').innerHTML +=
  preHeadingIcon
document.querySelector('.career__about--preHeadingIcon').innerHTML +=
  preHeadingIcon

// Arrow Up Icon Button
const arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.btn.btn-book-demo').forEach((el) => {
  el.innerHTML += arrowUpIcon
})

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.btn-hamburger').innerHTML += hamburgerIcon

const timelineCardIcon = `<svg width="100%" height="100%" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" rx="24" fill="white" fill-opacity="0.2"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M19.8327 22.2282C21.2704 21.8581 22.3327 20.553 22.3327 18.9998C22.3327 17.1589 20.8403 15.6665 18.9993 15.6665C17.1584 15.6665 15.666 17.1589 15.666 18.9998C15.666 20.553 16.7283 21.8581 18.166 22.2282V31.4998C18.166 31.9601 18.5391 32.3332 18.9993 32.3332C19.4596 32.3332 19.8327 31.9601 19.8327 31.4998V22.2282Z" fill="white" fill-opacity="0.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.666 28.9998C25.666 27.4466 26.7283 26.1416 28.166 25.7715V20.6665C28.166 20.4455 28.0782 20.2335 27.9219 20.0772C27.7657 19.921 27.5537 19.8332 27.3327 19.8332H24.8327C24.3724 19.8332 23.9993 19.4601 23.9993 18.9998C23.9993 18.5396 24.3724 18.1665 24.8327 18.1665H27.3327C27.9957 18.1665 28.6316 18.4299 29.1004 18.8987C29.5693 19.3676 29.8327 20.0035 29.8327 20.6665V25.7715C31.2704 26.1416 32.3327 27.4466 32.3327 28.9998C32.3327 30.8408 30.8403 32.3332 28.9993 32.3332C27.1584 32.3332 25.666 30.8408 25.666 28.9998Z" fill="white" fill-opacity="0.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M25.6667 29C25.6667 27.4468 26.729 26.1417 28.1667 25.7717V20.6667C28.1667 20.4457 28.0789 20.2337 27.9226 20.0774C27.7663 19.9212 27.5543 19.8334 27.3333 19.8334H24.8333C24.3731 19.8334 24 19.4603 24 19C24 18.5398 24.3731 18.1667 24.8333 18.1667H27.3333C27.9964 18.1667 28.6323 18.4301 29.1011 18.8989C29.5699 19.3678 29.8333 20.0036 29.8333 20.6667V25.7717C31.271 26.1417 32.3333 27.4468 32.3333 29C32.3333 30.841 30.8409 32.3334 29 32.3334C27.1591 32.3334 25.6667 30.841 25.6667 29Z" fill="white"/>
</svg>`

document.querySelectorAll('.timeline__about--cardLogo').forEach((el) => {
  el.innerHTML += timelineCardIcon
})

const linkedinIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.8333 17.5H7.5V7.5H10.8333V9.16667C11.5439 8.26271 12.6214 7.72381 13.7708 7.6975C15.838 7.70898 17.506 9.39115 17.5 11.4583V17.5H14.1667V11.875C14.0334 10.9439 13.2348 10.253 12.2942 10.255C11.8827 10.268 11.4944 10.4481 11.2187 10.7539C10.943 11.0596 10.8039 11.4644 10.8333 11.875V17.5ZM5.83333 17.5H2.5V7.5H5.83333V17.5ZM4.16667 5.83333C3.24619 5.83333 2.5 5.08714 2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5C5.08714 2.5 5.83333 3.24619 5.83333 4.16667C5.83333 4.60869 5.65774 5.03262 5.34518 5.34518C5.03262 5.65774 4.60869 5.83333 4.16667 5.83333Z"/>
</svg>`

document.querySelectorAll('.team__about--cardLinkedIn').forEach((el) => {
  el.innerHTML += linkedinIcon
})

const rectangleBottomCardActive =
  '<svg width="100%" height="14" viewBox="0 0 234 14" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><path d="M0 0H234L0 12V0Z" fill="white"/><path d="M0 12L234 0V2L0 14V12Z" fill="url(#paint0_linear_3145_6432)"/><defs><linearGradient id="paint0_linear_3145_6432" x1="-2" y1="10" x2="234" y2="1.54961e-05" gradientUnits="userSpaceOnUse"><stop stop-color="#05A6F0"/><stop offset="1" stop-color="#1DCA5D"/></linearGradient></defs></svg>'
const rectangleBottomCard =
  '<svg width="100%" height="14" viewBox="0 0 234 14" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"><path d="M0 0H234L0 12V0Z" fill="white"/><path d="M0 12L234 0V2L0 14V12Z" fill="#E2E8F0"/></svg>'

document.querySelectorAll('.team__about--cardRectangleBottom').forEach((el) => {
  el.innerHTML = rectangleBottomCard
})
document
  .querySelectorAll('.team__about--cardRectangleBottom.active')
  .forEach((el) => {
    el.innerHTML = rectangleBottomCardActive
  })

const arrowUpIconCardTeam = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.team__about--cardArrowUpIcon').forEach((el) => {
  el.innerHTML += arrowUpIconCardTeam
})

document.querySelectorAll('.swiper-slide.team__about--card').forEach((el) => {
  el.addEventListener('mouseenter', () => {
    // console.log('enter')
    el.querySelector('.team__about--cardRectangleBottom').innerHTML =
      rectangleBottomCardActive
  })
  el.addEventListener('mouseleave', () => {
    // console.log('leave')
    el.querySelector('.team__about--cardRectangleBottom').innerHTML =
      rectangleBottomCard
  })
})
// eslint-disable-next-line no-unused-vars
const swiper = new Swiper('.swiper.team__about--swiper', {
  // Optional parameters
  // direction: 'vertical',
  loop: false,
  // centeredSlides: true,
  slidesPerView: 1.145,
  spaceBetween: 24,

  // If we need pagination
  // pagination: {
  //   el: '.swiper-pagination'
  // },

  // Navigation arrows
  navigation: {
    nextEl: '.team__about--navigationNextBtn',
    prevEl: '.team__about--navigationPreviousBtn',
  },

  // And if we need scrollbar
  // scrollbar: {
  //   el: '.swiper-scrollbar'
  // }
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 2.5,
    },
    992: {
      slidesPerView: 3.21,
    },
    1200: {
      slidesPerView: 4,
    },
  },
})
// eslint-disable-next-line no-unused-vars
const swiperAboutTestimonial = new Swiper(
  '.swiper.testimonial__about--swiper',
  {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1.075,
    spaceBetween: 24,
    mousewheel: true,
    speed: 350,

    breakpoints: {
      //   576: {
      //     slidesPerView: 2
      //   },
      992: {
        centeredSlides: true,
        slidesPerView: 'auto',
        direction: 'vertical',
        //     slidesPerView: 2.5
      },
      //   992: {
      //     slidesPerView: 3.21
      //   },
      //   1200: {
      //     slidesPerView: 4
      //   }
    },
  },
)

setTimeout(function () {
  swiperAboutTestimonial.update()
}, 500)

const isLarge = window.matchMedia('(min-width: 992px)')

if (isLarge.matches) {
  // Then trigger an alert
  swiperAboutTestimonial.on('slideChange', function () {
    if (swiperAboutTestimonial.activeIndex === 0) {
      document.querySelector(
        '.swiper.testimonial__about--swiper .swiper-wrapper',
      ).style.marginTop = '0%'
      document
        .querySelector('.testimonial__about--swiper')
        .style.setProperty('--zIndexBefore-pseudo', 0)
      document
        .querySelector('.testimonial__about--swiper')
        .style.setProperty('--zIndexAfter-pseudo', 2)
    } else if (swiperAboutTestimonial.activeIndex === 4) {
      document.querySelector(
        '.swiper.testimonial__about--swiper .swiper-wrapper',
      ).style.marginBottom = '0%'
      document
        .querySelector('.testimonial__about--swiper')
        .style.setProperty('--zIndexBefore-pseudo', 2)
      document
        .querySelector('.testimonial__about--swiper')
        .style.setProperty('--zIndexAfter-pseudo', 0)
    } else {
      // document.querySelector('.testimonial__about--swiper::before').style.zIndex = 2
      document.querySelector(
        '.swiper.testimonial__about--swiper .swiper-wrapper',
      ).style.marginTop = 'auto'
      document.querySelector(
        '.swiper.testimonial__about--swiper .swiper-wrapper',
      ).style.marginBottom = 'auto'
      document
        .querySelector('.testimonial__about--swiper')
        .style.setProperty('--zIndexBefore-pseudo', 2)
      document
        .querySelector('.testimonial__about--swiper')
        .style.setProperty('--zIndexAfter-pseudo', 2)
    }
  })
}

const closeBtnPopUpIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 7L7 17M7 7L17 17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelector('.popupTeam__about--btnClose').innerHTML +=
  closeBtnPopUpIcon

const linkedInIcon =
  '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8333 17.5H7.5V7.5H10.8333V9.16667C11.5439 8.26271 12.6214 7.72381 13.7708 7.6975C15.838 7.70898 17.506 9.39115 17.5 11.4583V17.5H14.1667V11.875C14.0334 10.9439 13.2348 10.253 12.2942 10.255C11.8827 10.268 11.4944 10.4481 11.2187 10.7539C10.943 11.0596 10.8039 11.4644 10.8333 11.875V17.5ZM5.83333 17.5H2.5V7.5H5.83333V17.5ZM4.16667 5.83333C3.24619 5.83333 2.5 5.08714 2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5C5.08714 2.5 5.83333 3.24619 5.83333 4.16667C5.83333 4.60869 5.65774 5.03262 5.34518 5.34518C5.03262 5.65774 4.60869 5.83333 4.16667 5.83333Z" fill="#05A6F0"/></svg>'

document.querySelector('.popupTeam__about--urlLinkedinIcon').innerHTML +=
  linkedInIcon

const popUpAboutTeam = document.querySelector('.popupTeam__about')
const arrowUpCardTeamBtns = document.querySelectorAll(
  '.team__about--cardArrowUpIcon',
)
arrowUpCardTeamBtns.forEach((el, index) => {
  el.addEventListener('click', () => {
    const _dataTeam = ourTeams[index]

    popUpAboutTeam.querySelector('.popupTeam__about--photo .img').src =
      _dataTeam.photo
    popUpAboutTeam.querySelector('.popupTeam__about--name').innerHTML =
      _dataTeam.name
    popUpAboutTeam.querySelector('.popupTeam__about--jobTitle').innerHTML =
      _dataTeam.jobTitle
    popUpAboutTeam.querySelector(
      '.popupTeam__about--yearExperience',
    ).innerHTML = _dataTeam.yearsExperience + ' Years Experience'
    popUpAboutTeam.querySelector('.popupTeam__about--desc').innerHTML =
      _dataTeam.description
    popUpAboutTeam.querySelector('.popupTeam__about--urlLinkedin').href =
      _dataTeam.linkedInUrl

    popUpAboutTeam.style.display = 'flex'
  })
})

popUpAboutTeam
  .querySelector('.btn.popupTeam__about--btnClose')
  .addEventListener('click', () => {
    popUpAboutTeam.style.display = 'none'
  })
popUpAboutTeam
  .querySelector('.popupTeam__about--overlay')
  .addEventListener('click', () => {
    popUpAboutTeam.style.display = 'none'
  })

// Animation Single Element
const singleElements = [
  // Hero
  ['.hero__about--preHeading', 'animate__fadeInUp', 'animate__delay-1s'],
  ['.hero__about--title', 'animate__fadeInUpOneTenth', 'animate__delay-3s'],
  ['.hero__about--desc', 'animate__fadeInUpOneTenth', 'animate__delay-5s'],
  ['.hero__about--card', 'animate__fadeInUpOneTenth', 'animate__delay-7s'],
  [
    '.hero__about--illustration .img',
    'animate__fadeInUpOneTenth',
    'animate__delay-9s',
  ],
  // Our Values
  ['.ourValues__about--title', 'animate__fadeInUp', 'animate__delay-1s'],
  [
    '.ourValues__about--content',
    'animate__fadeInUpOneTenth',
    'animate__delay-1s',
  ],
  // About Testimonial
  [
    '.testimonial__about--left .testimonial__about--preHeading',
    'animate__fadeInUpOneTenth',
    'animate__delay-1s',
  ],
  [
    '.testimonial__about--title',
    'animate__fadeInUpOneTenth',
    'animate__delay-3s',
  ],
  [
    '.testimonial__about--illustration',
    'animate__fadeInUpOneTenth',
    'animate__delay-5s',
  ],
  [
    '.testimonial__about--right .testimonial__about--preHeading',
    'animate__fadeInUpOneTenth',
    'animate__delay-7s',
  ],
  [
    '.testimonial__about--swiper',
    'animate__fadeInUpOneTenth',
    'animate__delay-9s',
  ],
  // Our Teams
  ['.team__about--preHeading', 'animate__fadeInUp', 'animate__delay-1s'],
  ['.team__about--title', 'animate__fadeInUp', 'animate__delay-3s'],
  ['.team__about--swiper', 'animate__fadeInUpOneTenth', 'animate__delay-5s'],
  ['.team__about--footer', 'animate__fadeInUpOneTenth', 'animate__delay-7s'],
  // Team Activity
  [
    '.teamActivity__about--preHeading',
    'animate__fadeInUp',
    'animate__delay-3s',
  ],
  [
    '.teamActivity__about--title',
    'animate__fadeInUpOneTenth',
    'animate__delay-5s',
  ],
  [
    '.teamActivity__about--desc',
    'animate__fadeInUpOneTenth',
    'animate__delay-7s',
  ],
  // Career
  ['.career__about--preHeading', 'animate__fadeInUp', 'animate__delay-3s'],
  ['.career__about--title', 'animate__fadeInUpOneTenth', 'animate__delay-5s'],
  ['.career__about--desc', 'animate__fadeInUpOneTenth', 'animate__delay-7s'],
  [
    '.career__about--btnApplyNow',
    'animate__fadeInUpOneTenth',
    'animate__delay-9s',
  ],
  [
    '.career__about--illustration',
    'animate__fadeInUpOneTenth',
    'animate__delay-11s',
  ],
]

// Create the observer like the examples above
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      entry.target.classList.add(
        'animate__animated',
        singleElements[index][1],
        singleElements[index][2],
      )
    }

    // entry.target.classList.remove('animate__animated')
  })
})
// , { threshold: 0.25 }

singleElements.forEach((element) => {
  observer.observe(document.querySelector(element[0]))
})

// Animation CTA Element
const ctaElements = [
  // CTA
  ['.section-cta__title', 'animate__fadeInUp', 'animate__delay-1s'],
  ['.section-cta__description', 'animate__fadeInUp', 'animate__delay-3s'],
  ['.btn-book-demo', 'animate__fadeInUpOneTenth', 'animate__delay-5s'],
]

ctaElements.forEach((element) => {
  document.querySelectorAll(element[0]).forEach((el) => {
    observer.observe(el)
  })
})

const visiMissionElements = [
  // VisiMission
  ['.vision__about--title', 'animate__fadeInUp', 'animate__delay-1s'],
  ['.vision__about--subtitle', 'animate__fadeInUp', 'animate__delay-3s'],
  [
    '.vision__about--description',
    'animate__fadeInUpOneTenth',
    'animate__delay-5s',
  ],
  [
    '.vision__about--illustration',
    'animate__fadeInUpOneTenth',
    'animate__delay-7s',
  ],
]

visiMissionElements.forEach((element) => {
  document.querySelectorAll(element[0]).forEach((el) => {
    observer.observe(el)
  })
})

const timelineAboutEl = document.querySelector('.timeline__about')

// Create the observer like the examples above
const observerTimelineAbout = new IntersectionObserver((entries) => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      // entry.target.classList.add('animate__animated', singleElements[index][1], singleElements[index][2])
      entry.target
        .querySelector('.timeline__about--line')
        .classList.add('animate')
      entry.target.querySelectorAll('.timeline__about--card').forEach((el) => {
        el.classList.add('animate')
      })
    }

    // entry.target.classList.remove('animate__animated')
  })
})

observerTimelineAbout.observe(timelineAboutEl)

const testimonialCardParent = document.querySelector(
  '.swiper.testimonial__about--swiper .swiper-wrapper',
)

aboutTestimonials.forEach((aboutTestimonial) => {
  const aboutTestimonialCardEl = document
    .querySelector('[data-element="testimonial-about-card-slider"]')
    .cloneNode(true)
  aboutTestimonialCardEl.querySelector('[data-element="name"]').textContent =
    aboutTestimonial.name
  aboutTestimonialCardEl.querySelector(
    '[data-element="job-position"]',
  ).textContent = aboutTestimonial.jobPosition
  aboutTestimonialCardEl.querySelector(
    '[data-element="about-testimonial"]',
  ).innerHTML = aboutTestimonial.testimonial
  aboutTestimonialCardEl.querySelector('[data-element="company-logo"]').src =
    aboutTestimonial.companyLogo
  aboutTestimonialCardEl
    .querySelector('[data-element="company-logo"]')
    .classList.add(aboutTestimonial.companyLogoClass)
  aboutTestimonialCardEl.querySelector('[data-element="photo"]').src =
    aboutTestimonial.photo

  testimonialCardParent.appendChild(aboutTestimonialCardEl)
})
document
  .querySelectorAll('[data-element="testimonial-about-card-slider"]')[0]
  .remove()
